<template>
    <Teleport to="body">
        <ConfirmationDialog
            v-if="show"
            :show="show"
            title="Delete Entry"
            :dialog="`Are you sure you want to delete this points entry from ${entry?.dateFormatted}? This action cannot be undone.`"
            :buttons="[
                {
                    text: 'Cancel',
                    value: false,
                    type: 'cancel',
                    classes: 'border border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-gray-800 dark:text-gray-100',
                },
                {
                    text: 'Delete',
                    value: true,
                    type: 'confirm',
                    classes: '!bg-red-500 text-white',
                },
            ]"
            @cancel="$emit('cancel')"
            @confirm="$emit('confirm')"
        >
            <template #title>
                <div class="flex items-center gap-3 self-stretch">
                    <div
                        class="flex items-center justify-center w-12 h-12 p-3 rounded-full bg-red-100"
                    >
                        <Icon icon="delete" pathClass="fill-red-500" />
                    </div>
                    <span class="text-gray-800 dark:text-gray-100 text-xl font-medium leading-7">
                        Delete Entry
                    </span>
                </div>
            </template>
        </ConfirmationDialog>
    </Teleport>
</template>

<script setup>
import Icon from '@/components/ui/icon/icon.vue';
import ConfirmationDialog from '@/components/ui/confirmation-dialog/confirmation-dialog.vue';

const props = defineProps({
    show: {
        type: Boolean,
        required: true,
    },
    entry: {
        type: Object,
        default: null,
    },
});

defineEmits(['cancel', 'confirm']);
</script>
